/**
 * useTransferRoulettes — grupos de roleta disponíveis ao operador.
 *
 * Carrega via GET /api/contacts/transfer-roulettes os grupos que o usuário
 * pode usar (o admin vê todos; o membro só os allow_members). Cada grupo vira
 * um chip nomeado no AI Workspace do ChatWindow. assignToRoulette(phone,
 * groupId) distribui o contato pelo grupo (o header de responsável atualiza
 * sozinho via SSE CONTACT_ASSIGNMENT_CHANGED).
 *
 * A config muda raramente (só o admin edita na tela de Etiquetas), então
 * carregamos uma vez por montagem do ChatWindow — recarrega ao reabrir.
 */
import { useCallback, useEffect, useState } from 'react';
import assignmentService from '../services/global/assignmentService';

export default function useTransferRoulettes() {
  const [roulettes, setRoulettes] = useState([]);

  useEffect(() => {
    let cancelled = false;
    assignmentService
      .getTransferRoulettes()
      .then((res) => { if (!cancelled) setRoulettes(res?.data || []); })
      .catch((err) => {
        console.warn('[useTransferRoulettes] load failed:', err);
      });
    return () => { cancelled = true; };
  }, []);

  const assignToRoulette = useCallback(
    (phone, groupId) => assignmentService.assignRoulette(phone, groupId),
    []
  );

  return { roulettes, assignToRoulette };
}
